/**
 * 列表组件 - 金融机构列表
 * 包含：表格内容
 */

export default {
    name: 'ListComponent',

    props: {
        // 金融机构列表
        institutionList: {
            type: Array,
            default: () => []
        },
        // 底部文字
        bottomText: {
            type: String,
            default: '本平台将基于经营合作情况适时更新'
        },
        // 是否初始化完成
        isInit: {
            type: Boolean,
            default: false
        },
        // 是否为PC端
        isPc: {
            type: Boolean,
            default: false
        }
    },

    methods: {
        /**
         * 格式化网站URL
         * 确保域名有正确的协议前缀
         * 默认使用 HTTPS，对已知不支持 HTTPS 的域名使用 HTTP
         */
        formatWebsiteUrl(domain) {

            // 返回完整URL
            return 'http://' + domain
        },

        /**
         * 格式化机构名称（PC端）
         * 移除换行符和空格，使名称在一行紧凑显示
         */
        formatCompanyName(company) {
            if (!company) return ''
            // 先移除\n换行符，然后移除所有空格
            return company.replace(/\\n/g, '').replace(/\n/g, '').replace(/\s/g, '')
        }
    }
}